import * as Yup from 'yup';
import _ from 'lodash';
import { isSequentialOrRepeatable } from '../utils/index';
import { CONSTANT } from '../utils/constant';
import { getLocalizedStrings } from '../misc';

const {
  KEYS: { CHANNELS, ROLES }
} = CONSTANT;

const TECH_CHANNELS = {
  ADT: 'ADT',
  CSD: 'CSD',
  NBD: 'NBD'
};

// const isOutletIDRequired = (role, channel) => {
//   return (
//     ![
//       ROLES.TELUS_MANAGER,
//       ROLES.TECH,
//       ROLES.ADT_RETENTION,
//       ROLES.CBM,
//       ROLES.EPP
//     ].includes(role) &&
//     channel !== CHANNELS.HOME_SOLUTION &&
//     channel !== CHANNELS.BCX_CARE &&
//     channel !== CHANNELS.SBS_TI_SALES &&
//     channel !== TECH_CHANNELS.ADT &&
//     channel !== TECH_CHANNELS.CSD &&
//     channel !== TECH_CHANNELS.NBD
//   );
// };
// const isDealershipRequired = channel => _.get(channel, '0.id', '') === CHANNELS.DEALER;

// const isSalesManagerRequired = (role, channel) => {
//   if (!channel && role === ROLES.SALES_REP) {
//     return true;
//   }
//   if (role === ROLES.SALES_SUPPORT || role === ROLES.SALES_REP) {
//     return true;
//   }
//   if (role === ROLES.SALES_REP && channel === CHANNELS.HOME_SOLUTION) {
//     return false;
//   }
//   if (role === ROLES.TECH && channel === TECH_CHANNELS.ADT) {
//     return false;
//   }
//   if (role === ROLES.TECH && channel === TECH_CHANNELS.CSD) {
//     return false;
//   }
//   if (role === ROLES.TECH && channel === TECH_CHANNELS.NBD) {
//     return false;
//   }
//   return false;
// };

// const isSalesManagerEmailRequired = (role, channel) => {
//   if (!channel && role === ROLES.SALES_REP) {
//     return true;
//   }
//   if (role === ROLES.SALES_SUPPORT || role === ROLES.SALES_REP || role === ROLES.SALES_MANAGER) {
//     return true;
//   }
//   if (role === ROLES.SALES_REP && channel === CHANNELS.HOME_SOLUTION) {
//     return false;
//   }
//   if (role === ROLES.TECH && channel === TECH_CHANNELS.ADT) {
//     return false;
//   }
//   if (role === ROLES.TECH && channel === TECH_CHANNELS.CSD) {
//     return false;
//   }
//   if (role === ROLES.TECH && channel === TECH_CHANNELS.NBD) {
//     return false;
//   }
//   return false;
// };

// const isCmpsIDRequired = (role, channel) => {
//   return (
//     ![
//       ROLES.SALES_SUPPORT
//     ].includes(role)
//     // [CHANNELS.HOME_SOLUTION,
//     // CHANNELS.BCX_CARE]
//     // CHANNELS.CORP_STORE]
//     // .includes(_.get(channel, '0.value', ''))
//     // channel !== CHANNELS.HOME_SOLUTION &&
//     // channel !== CHANNELS.BCX_CARE &&
//     // channel !== CHANNELS.CORP_STORE
//   );
// };

// const isXIDRequired = (role, channel) => {
//   return (
//     ![
//       ROLES.TELUS_MANAGER,
//       ROLES.SALES_REP,
//       ROLES.SALES_MANAGER,
//       ROLES.TECH,
//     ].includes(role)
//     // channel === 3 ||  // BCX_CARE
//     // channel === 23 ||  // HOME_SOLUTIONS
//     // (channel === 19 && channel !== 17)   //CORP_STORE(19) & DEALER(17)
//   );
// };

const isChannelRequired = role => {
  return (
    role === ROLES.SALES_REP ||
    role === ROLES.SALES_MANAGER ||
    role === ROLES.TECH ||
    role === ROLES.SALES_SUPPORT
  );
};

const RegisterAsSalesRepAndManager = Yup.object().shape({
  role: Yup.string().required(() => {
    const {
      USERS: {
        USER_AUTHENTICATION: {
          labels: { SELECT_ROLE }
        }
      }
    } = getLocalizedStrings();
    return SELECT_ROLE;
  }),
  firstName: Yup.string().required(() => {
    const {
      USERS: {
        USER_AUTHENTICATION: {
          REGISTRATION_SCHEMA_MESSAGES: { FIRST_NAME_REQUIRED }
        }
      }
    } = getLocalizedStrings();
    return FIRST_NAME_REQUIRED;
  }),
  lastName: Yup.string().required(() => {
    const {
      USERS: {
        USER_AUTHENTICATION: {
          REGISTRATION_SCHEMA_MESSAGES: { LAST_LAST_REQUIRED }
        }
      }
    } = getLocalizedStrings();
    return LAST_LAST_REQUIRED;
  }),
  email: Yup.string()
    .email(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { INVALID_EMAIL }
          }
        }
      } = getLocalizedStrings();
      return INVALID_EMAIL;
    })
    .required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { EMAIL_REQUIRED }
          }
        }
      } = getLocalizedStrings();
      return EMAIL_REQUIRED;
    }),
  password: Yup.string()
    .required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { PASSWORD_REQUIRED }
          }
        }
      } = getLocalizedStrings();
      return PASSWORD_REQUIRED;
    })
    .matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { PASSWORD_MATCHES }
          }
        }
      } = getLocalizedStrings();
      return PASSWORD_MATCHES;
    })
    .test(
      'password',
      () => {
        const {
          USERS: {
            USER_AUTHENTICATION: {
              REGISTRATION_SCHEMA_MESSAGES: { PASSWORD_REPEAT }
            }
          }
        } = getLocalizedStrings();
        return PASSWORD_REPEAT;
      },
      isSequentialOrRepeatable
    ),
  contactNumber: Yup.string()
    .required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { CONTACT_REQUIRED }
          }
        }
      } = getLocalizedStrings();
      return CONTACT_REQUIRED;
    })
    .min(10, 'Contact Number must be 10 digits')
    .max(10, 'Contact Number no more than 10 digits')
    .matches(/^[0-9]+$/, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { MIN_BE_DIGIT_10 }
          }
        }
      } = getLocalizedStrings();
      return MIN_BE_DIGIT_10;
    }),
  provinces: Yup.string().required(() => {
    const {
      USERS: {
        USER_AUTHENTICATION: {
          REGISTRATION_SCHEMA_MESSAGES: { PROVINCE_REQUIRED }
        }
      }
    } = getLocalizedStrings();
    return PROVINCE_REQUIRED;
  }),
  channels: Yup.string().when('role', {
    is: isChannelRequired,
    then: Yup.string().required(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { CHANNEL_REQUIRED }
          }
        }
      } = getLocalizedStrings();
      return CHANNEL_REQUIRED;
    }),
    otherwise: Yup.string()
  }),
  // dealership: Yup.string().when('channels', {
  //   is: isDealershipRequired,
  //   then: Yup.string().required(() => {
  //     const {
  //       USERS: {
  //         USER_AUTHENTICATION: {
  //           REGISTRATION_SCHEMA_MESSAGES: { DEALERSHIP_REQUIRED }
  //         }
  //       }
  //     } = getLocalizedStrings();
  //     return DEALERSHIP_REQUIRED;
  //   }),
  //   otherwise: Yup.string()
  // }),
  storeCode: Yup.string()
    .when('channel', {
      is: CHANNELS.CORP_STORE,
      then: Yup.string()
        .required(() => {
          const {
            USERS: {
              USER_AUTHENTICATION: {
                REGISTRATION_SCHEMA_MESSAGES: { STORECODE_REQUIRED }
              }
            }
          } = getLocalizedStrings();
          return STORECODE_REQUIRED;
        })
    })
    ,
  channelOrgCode: Yup.string()
    // .when('channels', {
    //   is: isDealershipRequired,
    //   then: Yup.string()
    //     .required(() => {
    //       const {
    //         USERS: {
    //           USER_AUTHENTICATION: {
    //             REGISTRATION_SCHEMA_MESSAGES: { CHANNELORGCODE_REQUIRED }
    //           }
    //         }
    //       } = getLocalizedStrings();
    //       return CHANNELORGCODE_REQUIRED;
    //     })
    .min(5, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { MAX_5_DIGIT }
          }
        }
      } = getLocalizedStrings();
      return MAX_5_DIGIT;
    })
    .max(5, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { MIN_5_DIGIT }
          }
        }
      } = getLocalizedStrings();
      return MIN_5_DIGIT;
    }),
  xid: Yup.string()
    .min(7, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { XID_TID_LENGTH_7_8 }
          }
        }
      } = getLocalizedStrings();
      return XID_TID_LENGTH_7_8;
    })
    .max(8, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { XID_TID_LENGTH_7_8 }
          }
        }
      } = getLocalizedStrings();
      return XID_TID_LENGTH_7_8;
    }),
  outlet: Yup.string()
    .matches(/^\w+$/, () => {
      const {
        USERS: {
          FORM: {
            REGISTRATION_SCHEMA_MESSAGES: { ALPHANUMERIC }
          }
        }
      } = getLocalizedStrings();
      return ALPHANUMERIC;
    })
    .min(10, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { MUST_EXACTLY_10 }
          }
        }
      } = getLocalizedStrings();
      return MUST_EXACTLY_10;
    })
    .max(10, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { MAX_BE_DIGIT_10 }
          }
        }
      } = getLocalizedStrings();
      return MAX_BE_DIGIT_10;
    }),
  cpmsId: Yup.string()
    .matches(/^[a-zA-Z0-9]+$/, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { ALPHANUMERIC }
          }
        }
      } = getLocalizedStrings();
      return ALPHANUMERIC;
    })
    .min(4, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { MAX_4_DIGIT }
          }
        }
      } = getLocalizedStrings();
      return MAX_4_DIGIT;
    })
    .max(4, () => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { MIN_4_DIGIT }
          }
        }
      } = getLocalizedStrings();
      return MIN_4_DIGIT;
    }),
  // salesManager: Yup.string()
  // .when(['role', 'channel'], {
  //   is: isSalesManagerRequired,
  //   then: Yup.string().required(() => {
  //     const {
  //       USERS: {
  //         USER_AUTHENTICATION: {
  //           REGISTRATION_SCHEMA_MESSAGES: { SALES_MANAGER_REQUIRED }
  //         }
  //       }
  //     } = getLocalizedStrings();
  //     return SALES_MANAGER_REQUIRED;
  //   }),
  //   otherwise: Yup.string()
  // }),

  salesManagerEmail: Yup.string()
    // .when(['role', 'channel'], {
    //   is: isSalesManagerEmailRequired,
    //   then: Yup.string()
    //     .required(() => {
    //       const {
    //         USERS: {
    //           USER_AUTHENTICATION: {
    //             REGISTRATION_SCHEMA_MESSAGES: { SALES_MANAGER_EMAIL_REQUIRED }
    //           }
    //         }
    //       } = getLocalizedStrings();
    //       return SALES_MANAGER_EMAIL_REQUIRED;
    //     })
    .email(() => {
      const {
        USERS: {
          USER_AUTHENTICATION: {
            REGISTRATION_SCHEMA_MESSAGES: { INVALID_EMAIL }
          }
        }
      } = getLocalizedStrings();
      return INVALID_EMAIL;
    }),
});

export default RegisterAsSalesRepAndManager;
